"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADDRESS_BOOKS = void 0;
var ADDRESS_BOOKS = exports.ADDRESS_BOOKS = {
  'tyw-footer': 'V6YvEG',
  'tyw-welcome': 'RMcZLC',
  'croatia-signup': 'Ut8WYg',
  'greece-signup': 'SdxMAi',
  'ultra-signup': 'SHUzH2',
  'drumcode-signup': 'VRB4Qv',
  'sardinia-signup': 'VEjxZc',
  'bvi-signup': 'Xfgav3',
  '2024-see-post-bo': 'UwtdcX',
  '2024-think-post-bo': 'YmMZit',
  'tyw-contact-page': 'XsSbv9',
  'tyw-why-yacht-week-page': 'SmRibi',
  'sardinia-refined-signup': 'SDMNYS',
  'summer-of-love': 'WfNktF',
  'tsw-signup-2025': 'YdDjUS',
  'tsw-footer': 'VhA6cv',
  'lead-booker': 'VKXGqr',
  'save-your-summer': 'UJVLEx',
  'ultra-week-signup': 'TkWkHs',
  'peche-week-signup': 'R4xCPZ',
  'raw-week-signup': 'SP9Nuz',
  'vibras-week-signup': 'WzRkeF'
  // 'tsw-signup-2021': '',
  // 'tsw-signup-2023': '',
  // 'tsw-socials-signup-2022': '',
  // 'chamonix-solo': '',
  // 'chamonix-solo-weekend': '',
  // 'ynf-footer': '',
  // 'ynf-croatia-signup': '',
  // 'ynf-greece-signup': '',
  // 'ynf-tahiti-signup': '',
  // 'ynf-salt-escapes-signup': '',
  // 'ynf-sicily-yoga-signup': '',
  // 'hideout-signup': '',
};